var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border rounded",staticStyle:{"border":"1px solid #d8d6de"}},[_c('div',{ref:"",attrs:{"id":"codex-editor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }